<script lang="ts">

  import { current } from "$lib/global-date"
  import { appStore } from "$lib/stores/app-store.svelte"
  import ChevronDownIcon from "@lucide/svelte/icons/chevron-down"
  import CloudSunIcon from "@lucide/svelte/icons/cloud-sun"
  import MoonStarIcon from "@lucide/svelte/icons/moon-star"
  import SunDimIcon from "@lucide/svelte/icons/sun-dim"
  import SunIcon from "@lucide/svelte/icons/sun"

  let {
    prefix,
  }: {
    prefix: string
  } = $props()

  const user = $derived(appStore.user)

  const hour = current().hour

  const day = $derived.by(() => {
    if (hour >= 18 || hour < 3) {
      return {
        name: "Malam",
        icon: MoonStarIcon,
        iconClass: "text-blue-500",
        color: "from-blue-50",
      }
    }

    if (hour >= 16) {
      return {
        name: "Sore",
        icon: SunDimIcon,
        iconClass: "text-orange-500",
        color: "from-orange-50",
      }
    }

    if (hour >= 11) {
      return {
        name: "Siang",
        icon: SunIcon,
        iconClass: "text-yellow-500",
        color: "from-yellow-50",
      }
    }

    return {
      name: "Pagi",
      icon: CloudSunIcon,
      iconClass: "text-sky-500",
      color: "from-sky-50",
    }
  })

  const DayIcon = $derived(day.icon)

</script>

<a
  href={`/${prefix}/staff-select`}
  class="relative block overflow-hidden rounded-lg border">
  <div class={`absolute end-0 top-0 h-full w-40 bg-gradient-to-l to-transparent ${day.color}`}></div>
  <div class="absolute end-0 top-0">
    <DayIcon class={`size-28 opacity-25 ${day.iconClass}`}/>
  </div>
  <div class="flex items-center justify-between px-3 py-2">
    <div class="relative flex-1 text-xs">
      <div class="font-light">Selamat {day.name}</div>
      <div class="h-2"></div>
      <div class="font-semibold">{user?.name}</div>
      <div class="font-light">{user?.employee.number}</div>
      <div class="w-72 truncate font-light">{user?.employee.position}</div>
    </div>
    <div class="w-16"></div>
  </div>
  <div class="relative text-xs">
    <ChevronDownIcon
      size={18}
      class="justify-self-center"/>
  </div>
</a>
